import { Card, VField, VInput, VTextarea } from "@/components/ui";
import type { ExtraInfo } from "@/domains/requests/api/types";

type StepExtraInfoProps = {
  value: ExtraInfo;
  onChange: (next: ExtraInfo) => void;
};

export function StepExtraInfo({ value, onChange }: StepExtraInfoProps): React.JSX.Element {
  const patch = (partial: Partial<ExtraInfo>): void => onChange({ ...value, ...partial });

  return (
    <Card padding="lg" className="space-y-4">
      <VField
        label="17. Evenement"
        htmlFor="event"
        hint="Indien van toepassing: geef hier de naam van het evenement waarvoor de camera wordt aangevraagd."
      >
        <VInput
          id="event"
          value={value.event}
          onChange={(e) => patch({ event: e.target.value })}
        />
      </VField>

      <VField
        label="18. Info evenement"
        htmlFor="eventInfo"
        hint="Bij toepassing van een evenement, geef de noodzakelijke info zoals onder andere openingsuren, motivatie, doel inzet, …"
      >
        <VTextarea
          id="eventInfo"
          rows={4}
          value={value.eventInfo}
          onChange={(e) => patch({ eventInfo: e.target.value })}
        />
      </VField>

      <VField
        label="19. Info parkeerborden"
        htmlFor="parkingSigns"
        hint="Indien er parkeerborden moeten voorzien worden voor de plaatsing, vul hier de straatnaam en huisnummer in. Opgelet: je doet de plaatsing van parkeerborden zelf via de meldkaart."
      >
        <VTextarea
          id="parkingSigns"
          rows={3}
          value={value.parkingSigns}
          onChange={(e) => patch({ parkingSigns: e.target.value })}
        />
      </VField>
    </Card>
  );
}
